import React from "react";

import Box from "@mui/material/Box";
import slugify from "react-slugify";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import { WEB_URL } from "../api/URLs";
import { S3_BUCKET, } from '../constants';
import DefaultCover from "../assets/images/cover.jpg";
import { MixPanelTrackedLink, ProgressBar } from './';
import { StyledTopPagesTeams } from "./StyledComponents/TopPagesAndTeamsStyles";

export function TopPagesAndTeams({ topTeams, topPages }) {
    
    const calculateImpactPercentage = (fundraiser) => {
        let impactPercentage = Math.round((fundraiser.impact / fundraiser.total_impact) * 100);
        if (impactPercentage > 100) {
            impactPercentage = 100;
        }
        return impactPercentage
    }

    const mapFundraiserCards = (fundraiserArray) => {
        return fundraiserArray?.map((fundraiser, index) => {
            return <Stack className="FundraiserCard" key={index}>
                <Box className="ImageBox">
                    <img
                        src={S3_BUCKET + fundraiser.cover_image}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = DefaultCover
                        }}
                    />
                </Box>
                <Box className="DetailsBox">
                    <MixPanelTrackedLink
                        type="link"
                        label={fundraiser.page_title}
                        context="Page link from the top fundraisers section on home page"
                        underline="none"
                        color="inherit"
                        linkButtonProps={{ className: "PageTitle" }}
                        href={WEB_URL.FUNDRAISER_DETAILS(fundraiser.event_id, slugify(fundraiser.page_title))}
                    >
                        <Typography title={fundraiser.page_title} variant="bold">{fundraiser.page_title}</Typography>
                    </MixPanelTrackedLink>
                    <ProgressBar percentage={calculateImpactPercentage(fundraiser)} />
                    <Typography variant="small" fundraising-goal={fundraiser.fundraising_goal} total-fund-raised={Math.round(fundraiser.total_fund_raised)} per_child_cost_yearly={fundraiser.per_child_cost_yearly}>
                        Impacting {fundraiser?.impact?.toLocaleString() || 0} children
                    </Typography>
                </Box>
            </Stack>
        })
    }

    return <StyledTopPagesTeams className="TopPagesSection">
        <Container>
            <Stack className="TopPagesStack">
                <Box className="TopPagesBox">
                    <Typography className="PagesHeader">Top Fundraisers</Typography>
                    <Divider />
                    {topPages && mapFundraiserCards(topPages)}
                </Box>
                <Box className="TopPagesBox">
                    <Typography className="PagesHeader">Top Teams</Typography>
                    <Divider />
                    {topTeams && mapFundraiserCards(topTeams)}
                </Box>
            </Stack>
        </Container>
    </StyledTopPagesTeams>
}